// extracted by mini-css-extract-plugin
export default {"panel":"ControlPanel_panel__S1dOv","disabled":"ControlPanel_disabled__7u8pC"};